export const itFaq = [
  {
    question: "Per quanto tempo le informazioni sono consultabili?",
    response: (
      <div>
        Le informazioni sono disponibili in prossimità dell'intervento e <u>sino a 24 ore dopo</u> la fine
        dell'intervento ossia dopo l'uscita del paziente dal blocco operatorio
      </div>
    ),
  },
  {
    question: "Quali informazioni sono visualizzate?",
    response: (
      <>
        <div>
          Le informazioni sono visualizzate dopo che l'intervento è stato pianificato. Se viene eseguita la ricerca
          prima che l'intervento venga pianificato il sistema restituisce un messaggio di errore. Lo stesso messaggio
          viene visualizzato se sono trascorse più di 24 ore dall'uscita dal blocco operatorio.
        </div>
        <br />
        <div>
          Le informazioni disponibili riguardano il progresso del paziente attraverso le principali fasi temporali
          dell'intervento, nella sequenza:
        </div>
        <div className="sequenzaStati">
          <span>Ingresso in blocco operatorio</span>
          <span>Ingresso in sala operatoria</span>
          <span>Uscita da sala operatoria</span>
          <span>Uscita da blocco operatorio</span>
        </div>
        <br />
        <div>
          A ogni evento della sequenza è associata l'ora in cui si è verificato l'evento, se disponibile e nel passato
        </div>
        <br />
        <div>È inoltre visualizzato l'avanzamento del paziente nella sequenza</div>
      </>
    ),
  },
  {
    question: "Quali sono gli stati di avanzamento possibili?",
    response: (
      <div>
        La sequenza degli stati di avanzamento possibili è:
        <div className="sequenzaStati">
          <span>
            “Intervento pianificato”: l'intervento è stato inserito nella pianificazione ma non è ancora iniziato, non è
            visualizzata alcuna ora, tutti gli eventi sono “non ancora iniziato”
          </span>
          <span>
            “In blocco operatorio”: il paziente è stato trasferito nel blocco operatorio ma l'evento chirurgico non è
            ancora iniziato, è visualizzata l'ora di ingresso nel blocco operatorio
          </span>
          <span>
            “Intervento in corso”: l'evento chirurgico è in corso, è visualizzata l'ora di ingresso in sala operatoria
          </span>
          <span>
            “Post operatorio”: il paziente è ancora nel blocco operatorio, è visualizzata l'ora di uscita dalla sala
            operatoria
          </span>
          <span>
            “Intervento terminato”: il paziente è uscito dal blocco operatorio ed è in trasferimento o è già in reparto;
            è visualizzata l'ora di uscita dal blocco operatorio
          </span>
        </div>
      </div>
    ),
  },
  {
    question: "Che significato hanno gli indicatori lungo la linea temporale visualizzata?",
    response: (
      <div>
        Gli indicatori possono assumere tre valori “non ancora iniziato”, “in corso”, “concluso”, che si riferiscono al
        passo nella sequenza immediatamente successivo all'evento.
        <br />
        Se l'evento non si è ancora verificato l'indicatore assume il valore “non ancora iniziato”. Se l'evento si è
        verificato ma non si è ancora verificato quello successivo, l'indicatore assume il valore “in corso”. Se si è
        già verificato l'evento successivo nella linea temporale, l'indicatore assume il valore “concluso”.
      </div>
    ),
  },
];
